import { get, sortBy } from 'lodash';
import { modules, User as veritoneUser } from '@veritone/glc-redux';

import { TDOId } from '@cbsa-modules/universal';

const {
  config: { getConfig },
  user,
} = modules;

// ETODO No longer in use!
export const selectDetectionEngines = (tdo: any, state: any) => {
  const { detectionCategory, detectionEngineId } =
    getConfig<Window['config']>(state);
  // TODO: Potentially remove if not used
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return selectDetectionEnginesByConfig(
    tdo,
    detectionCategory,
    detectionEngineId
  );
};

// ETODO No longer in use!
/**
 * Select Face Recognition Engines by Category Id.
 */
// TODO: This whole function needs to be validated/fixed
export const selectDetectionEnginesByConfig = (
  tdo: any,
  detectionCategory: string,
  detectionEngineId: string
) => {
  // TODO: Fix these types
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
  const engineIds = get(tdo, 'tasks.records', [])
    .map((task: any) => !!task.engine) // TODO: This isn't correct -- will be boolean[] -- is this code event used?
    .filter((engine: any) => engine.categoryId === detectionCategory)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((engine: any) => engine.id)
    .filter((id: any) => !!id);
  // finally check, is there some engines?
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return engineIds.length !== 0 ? engineIds : [detectionEngineId];
};

export type User = Omit<veritoneUser, 'organization'> & {
  organization: veritoneUser['organization'] & { integrations: string[] };
};

export const selectUser = user.selectUser;

/**
 * MergeTdos Functions
 */

export interface Mergeable {
  readonly tdoId: TDOId;
  readonly startOffsetMs: number;
  readonly stopOffsetMs: number;
  readonly jsondata: {
    readonly series: ReadonlyArray<{
      readonly startTimeMs: number;
      readonly stopTimeMs: number;
      readonly object?: {
        readonly label?: string;
      };
    }>;
  };
}

export const mergeRecords: {
  <M extends Mergeable>(currentRecs: M, recsToMerge: M | null | undefined): M;
  <M extends Mergeable>(currentRecs: M | null | undefined, recsToMerge: M): M;
} = <M extends Mergeable>(currentRecs: M, recsToMerge: M): M => {
  if (!recsToMerge) {
    return currentRecs;
  }
  if (!currentRecs) {
    return recsToMerge;
  }

  return {
    ...currentRecs,
    jsondata: mergeJsonData(
      get(currentRecs, 'jsondata', { series: [] }),
      get(recsToMerge, 'jsondata', { series: [] })
    ),
    startOffsetMs: Math.min(
      currentRecs.startOffsetMs,
      recsToMerge.startOffsetMs
    ),
    stopOffsetMs: Math.max(currentRecs.stopOffsetMs, recsToMerge.stopOffsetMs),
  };
};

const mergeJsonData = <M extends Mergeable>(
  objOne: M['jsondata'],
  objTwo: M['jsondata']
): M['jsondata'] =>
  //
  ({
    ...objOne,
    series: mergeSeries(objOne.series, objTwo.series),
  });

const mergeSeries = <M extends Mergeable>(
  s1: M['jsondata']['series'],
  s2: M['jsondata']['series']
): M['jsondata']['series'] => {
  const series = sortBy([...s1, ...s2], 'startTimeMs');

  // find/merge polys that overlap because of
  // being split between engine result boundaries.

  // this loop could probably be optimized but runs fast enough for now
  const noDups = [];
  let i = 0;
  while (i < series.length) {
    const curr = series[i]!; // Safe due to length check above
    // step forward looking for duplicates
    for (let fi = i + 1; fi < series.length; fi++) {
      const forw = series[fi]!; // Safe due to length check above
      // break once the forward object is ahead
      if (forw.startTimeMs !== curr.startTimeMs) {
        break;
      }

      // if same stopTimeMs and label, assume fwd is duplicate. Skip fwd on next iter
      if (
        forw.stopTimeMs === curr.stopTimeMs &&
        forw.object?.label === curr.object?.label
      ) {
        i++;
      }
    }

    noDups.push(curr);
    i++;
  }

  // very old junk version
  // The code below stomps on previous results.
  // const newSeries: ElementOf<M['jsondata']['series']>[] = [series[0]];
  // let ni = 0;
  // for (let i = 1; i < series.length; i++) {
  //   const s = series[i];
  //   const ns = newSeries[ni];
  //   if (s.startTimeMs < ns.stopTimeMs) {
  //     newSeries[ni] = {
  //       ...ns,
  //       startTimeMs: Math.min(ns.startTimeMs, s.startTimeMs),
  //       stopOffsetMs: Math.max(ns.stopTimeMs, s.stopTimeMs),
  //     };
  //   } else {
  //     ni++;
  //     newSeries[ni] = s;
  //   }
  // }

  return noDups;
};

/* Helper functions */

export const isImage = (tdo: {
  primaryAsset?: {
    contentType?: string;
  };
  name?: string;
}) =>
  tdo?.primaryAsset?.contentType?.includes('image') ||
  tdo?.name?.match(/.(jpg|jpeg|png|gif)$/i);
